import { createElement, memo, useState } from '@max/max';
import CrossEndVapView from './index.web';
import { getIsSupportVap } from './utils';
const isMRN = false;
import { TechStackUtil } from '@nibfe/mkt-common-utils';
const VapView = (props) => {
    const isHarmony = TechStackUtil.isInHarmony();
    const [isSupportVap] = useState(getIsSupportVap());
    if (!isSupportVap) {
        return null;
    }
    return <CrossEndVapView {...props}/>;
};
export default memo(VapView);
